import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import SearchIcon from '@mui/icons-material/Search';
import { Box, Button, InputAdornment, Paper, TextField, Typography } from '@mui/material';
import { useState } from 'react';

import { formatCpf, hasValidCpfLength, onlyDigits } from '@utils/cpf';

export interface CpfSearchFormProps {
  onSearch: (cpf: string) => void;
  isLoading: boolean;
}

export const CpfSearchForm = ({ onSearch, isLoading }: CpfSearchFormProps) => {
  const [cpf, setCpf] = useState('');
  const [error, setError] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCpf(formatCpf(e.target.value));
    setError('');
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!hasValidCpfLength(cpf)) {
      setError('Informe um CPF com 11 dígitos');
      return;
    }
    onSearch(onlyDigits(cpf));
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 6 }}>
      <Box sx={{ textAlign: 'center', maxWidth: 600, mb: 4, px: 2 }}>
        <Typography variant="h4" component="h1" color="primary" sx={{ fontWeight: 700, mb: 1 }}>
          Gerenciador de Dados do Perfil do Cidadão
        </Typography>
      </Box>

      <Paper sx={{ p: 5, width: '100%', maxWidth: 480 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 }}>
          <PersonSearchIcon color="primary" fontSize="large" />
          <Typography variant="h5">Buscar Cidadão</Typography>
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Informe o CPF para localizar e editar o perfil do cidadão.
        </Typography>

        <Box component="form" onSubmit={handleSubmit} noValidate aria-label="Buscar cidadão">
          <TextField
            label="CPF"
            fullWidth
            value={cpf}
            onChange={handleChange}
            error={!!error}
            helperText={error || 'Ex.: 000.000.000-00'}
            autoComplete="off"
            inputProps={{ inputMode: 'numeric' }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" />
                </InputAdornment>
              ),
            }}
            sx={{ mb: 3 }}
          />
          <Button type="submit" variant="contained" fullWidth size="large" disabled={isLoading}>
            {isLoading ? 'Buscando...' : 'Buscar'}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};
